var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetterCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.3335 3.99999C3.89147 3.99999 3.46755 4.17558 3.15498 4.48815C2.84242 4.80071 2.66683 5.22463 2.66683 5.66666V7.99999H6.00016V5.66666C6.00016 5.22463 5.82457 4.80071 5.51201 4.48815C5.19945 4.17558 4.77552 3.99999 4.3335 3.99999ZM7.3335 5.66666C7.3335 4.87101 7.01742 4.10795 6.45482 3.54534C5.89221 2.98273 5.12915 2.66666 4.3335 2.66666C3.53785 2.66666 2.77478 2.98273 2.21218 3.54534C1.64957 4.10795 1.3335 4.87101 1.3335 5.66666V12.6667C1.3335 13.0348 1.63197 13.3333 2.00016 13.3333C2.36835 13.3333 2.66683 13.0348 2.66683 12.6667V9.33332H6.00016V12.6667C6.00016 13.0348 6.29864 13.3333 6.66683 13.3333C7.03502 13.3333 7.3335 13.0348 7.3335 12.6667V5.66666ZM11.6668 8.66666C10.7464 8.66666 10.0002 9.41285 10.0002 10.3333C10.0002 11.2538 10.7464 12 11.6668 12C12.5873 12 13.3335 11.2538 13.3335 10.3333C13.3335 9.41285 12.5873 8.66666 11.6668 8.66666ZM13.3505 7.84994C12.8704 7.52386 12.2909 7.33332 11.6668 7.33332C10.01 7.33332 8.66683 8.67647 8.66683 10.3333C8.66683 11.9902 10.01 13.3333 11.6668 13.3333C12.2909 13.3333 12.8704 13.1428 13.3505 12.8167C13.4185 13.1126 13.6836 13.3333 14.0002 13.3333C14.3684 13.3333 14.6668 13.0348 14.6668 12.6667V7.99999C14.6668 7.6318 14.3684 7.33332 14.0002 7.33332C13.6836 7.33332 13.4185 7.55401 13.3505 7.84994Z",
    fill: "white",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterCase);
export default __webpack_public_path__ + "static/media/letterCase.486c998e5de57eab49c72b6ef20eb415.svg";
export { ForwardRef as ReactComponent };